// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Jkv13","wrapper":"Card_wrapper__FnXZ9","header":"Card_header__bGC3q","titleWrapper":"Card_titleWrapper__PwTpv"};